const DeferenceCapabilityScreen = () => {
    return(
        <p>Deference Capability Screen</p>
    )
}

export default DeferenceCapabilityScreen